import { axiosClient } from '../../../library/Service/axiosClient';
import { REPORT_CONFIG } from '../reports/report-config';
import PageConfigAllBasReport  from './PageConfigAllBasReport.json';

class BasAdminReportService {
    static pageLoader(params: any): Promise<any> {
        const state: any = {};
        const searchCriteria = this.getDefaultSearchCriteria(params.pageName);

        if (params?.schoolId) searchCriteria.schoolId.push(params.schoolId);
        if (params?.counsellorId) searchCriteria.counsellorId.push(params.counsellorId);
        if (params?.sessionBookedStatus) searchCriteria.sessionBookedStatus.push(params.sessionBookedStatus);

     return Promise.all([
                this.getPageConfig(),
                this.search(searchCriteria, params.pageName),
                this.getDynamicFilterDomains()
            ]).then(([formconfig, alumniResponse, filterDomains]) => {
                state.formConfig = formconfig;
                state.data = {
                alumniList: alumniResponse?.data ?? [],
                searchCriteria,
                filterDomains
                };
                state.routeInfo = params;
                state.internal = { gridState: {} };

                return Promise.resolve(state);
            });

    }

    static getPageConfig() {
        return Promise.resolve(PageConfigAllBasReport);
    }

    static async getDynamicFilterDomains() {
        try {
            const response = await axiosClient().get(`${process.env.REACT_APP_BAS_API}/bas/bas-filters`);
            return response?.data || {}; // <-- return only the inner `data` which contains domain categories
        } catch (error) {
            console.error('Failed to fetch dynamic filter domains:', error);
            return {};
        }
    }

    static getDefaultSearchCriteria(pageName: string = ''): any {
        return {
            passOutYear: [],
            schoolId: [],
            clientType:[],
            counsellor:[],
            sessionBookedStatus:[],
            sessionDoneFrom:null,
            sessionDoneTo:null,
            sessionBookFrom:null,
            sessionBookTo:null,
            bookingMode:[],
            counsellingStage:[],
            student3cPrefStatus:[],
            psychometricTest:[],
            testStatus:[],
            counsellingStatus:[],
            parentPaceStatus:[],
            programId: [],
            isEmailVerified: "YES",
            counsellorId:[],
            sessionBookedForFromDate:[],
            sessionBookedForToDate:'',
            sessionBookedOnFromDate:[],
            sessionBookedOnToDate:'',
            preferenceCountryCode:[],
            preferenceCourse:[],
            preferenceColleges:[], 
            counsellorPreferenceCountryCode:[], 
            counsellorPreferenceCourse:[]   ,
            counsellorPreferenceColleges : [],
            paceFormparentCountryCode :[],
            paceFormparentCourseCode: [],
            paceFormparentColleges:[],    
            sdStatus:[], 
        };
    }

    static search(searchCriteria: any, pageName: string) {
        const config = REPORT_CONFIG[pageName];
        const criteria = this.sanitizeCriteria(searchCriteria, pageName);
        return axiosClient().post(`${process.env.REACT_APP_BAS_API}/bas/${config.SEARCH_API}`, criteria);
    }

     static fetchTestSessions(userId: any) {
        return axiosClient().post(`${process.env.REACT_APP_BAS_API}/bas/fetch-test-sessions`, {userId});
    }
    
    static searchCount(searchCriteria: any, pageName: string) {
        const criteriaCopy = { ...searchCriteria };
        const criteria = this.sanitizeCriteria(criteriaCopy, pageName);
        return axiosClient().post(`${process.env.REACT_APP_BAS_API}/bas/all-bas-count`, criteria);
    }

    static sanitizeCriteria(searchCriteria: any, pageName: any) {
        const criteria = { ...searchCriteria };
        for (const [key, value] of Object.entries(searchCriteria)) {
            criteria[key] = Array.isArray(value) && typeof value[0] === 'object' ? value.map((obj) => Object.values(obj)[0]) : value;
        }

        if (['YES', 'NO'].includes(criteria['isEmailVerified'])) {
            criteria['isEmailVerified'] = criteria['isEmailVerified'] === 'YES' ? 1 : 0;
        }

        return criteria;
    }
}

export default BasAdminReportService;
